import { UseQueryOptions, queryOptions } from '@tanstack/react-query';

import { SearchProductsParams, SearchProductsResponse, searchProducts } from '~/apis/search';

export const searchProductsQueryOptions = (
  request: SearchProductsParams,
  { enabled, staleTime }: Pick<UseQueryOptions, 'enabled' | 'staleTime'>,
  token = '',
) => {
  return queryOptions({
    queryKey: ['search', 'products', { ...request }],
    queryFn: () => {
      return searchProducts(request, {
        ...(token && {
          headers: {
            'X-BUN-AUTH-TOKEN': token,
          },
        }),
      }) as Promise<SearchProductsResponse>;
    },
    select: (data) => data.data,
    enabled,
    staleTime: staleTime ?? 3 * 1000,
    throwOnError: true,
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
